import Row from 'antd/lib/row'

import 'antd/lib/row/style'

export * from 'antd/lib/row'

export default Row
